import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import WebsiteContactRequestsTable from "./Componates/WebsiteContactRequestsTable";

const WebsiteContactRequestsList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Website Contact Requests</HeadingOne>
        </>
      }
    >
      <div className="col-12">
        <WebsiteContactRequestsTable />
      </div>
    </PageBody>
  );
};

export default WebsiteContactRequestsList;
